import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DescriptionBottomInfoContainer = styled.div<React.CSSProperties>`
  align-items: center;
  display: flex;
  height: ${Screen.widthRatio * 56}px;
  margin-top: ${Screen.widthRatio * 26}px;
`;

export default DescriptionBottomInfoContainer;
